import DetailsHeader from "./components/DetailsHeader";
import DetailsFooter from "./components/DetailsFooter";
import BottomSheetOverlay from "@Components/BottomSheetOverlay";

import styles from "./PropertyDetailsModal.module.scss";
import { IButton } from "@Components/Button/constants";
import Modal from "@Components/Modal";
import wrapperHOC from "@Utils/wrapperHOC";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";

type AllowedSize = "" | "fitContent" | "halfHeight" | "threeFourthHeight" | "fullHeight";
type PropertyDetailsModalProps = {
  header: any;
  hidePropertyModal: any;
  actionButtonText?: string;
  actionButtonVariant?: IButton["variant"];
  actionButtonClick?: () => void;
  children: React.ReactNode;
  removeFooter?: boolean;
  reducedZIndex?: boolean;
  isDesktop?: boolean;
  showResetButton?: boolean;
  resetButtonClick?: () => void;
  disableReset?: boolean;
  disableActionButton?: boolean;
  actionButtonStyle?: any;
  bodyWithNoPadding?: boolean;
  bodyWithEvenPadding?: boolean;
  mobileSize?: AllowedSize;
  fitContent?: boolean;
  isListingPage?: boolean;
  modalClassName?: string;
  isHistoryPush?: boolean;
  bottomSheetClassName?: string;
  noBodyLock?: boolean;
  sidePanel?: boolean;
};

const PropertyDetailsModal = ({
  header,
  hidePropertyModal,
  actionButtonText,
  actionButtonVariant,
  actionButtonClick,
  children,
  removeFooter = false,
  reducedZIndex = false,
  isDesktop = false,
  showResetButton = false,
  resetButtonClick,
  disableReset = false,
  disableActionButton = false,
  actionButtonStyle = {},
  bodyWithNoPadding = false,
  bodyWithEvenPadding = false,
  mobileSize = undefined,
  fitContent = false,
  isListingPage = false,
  modalClassName = "",
  isHistoryPush: isHistoryPushProp,
  bottomSheetClassName = "",
  noBodyLock = false,
  sidePanel = false,
}: PropertyDetailsModalProps) => {
  const shouldHistoryPush = isHistoryPushProp !== undefined ? isHistoryPushProp : !isDesktop;
  return (
    <>
      {isDesktop ? (
        <Modal
          hideModal={hidePropertyModal}
          size={sidePanel ? null : "medium"}
          align={sidePanel ? "right" : "center"}
          type="DetailsModal"
          animation={sidePanel ? "rightToLeftAnimation" : "opacity"}
          className={formatClassNames(
            sidePanel ? styles.sidePanelContainer : styles.modalContainer,
            modalClassName,
          )}
          zIndex={reducedZIndex ? 100 : 99999}
          closeBtnClassName={styles.closeBtnClassName}
          isHistoryPush={shouldHistoryPush}
        >
          <div className={styles.wrapper}>
            <DetailsHeader header={header} />
            <div
              className={formatClassNames(
                styles.detailsBody,
                bodyWithNoPadding && styles.noPadding,
                bodyWithEvenPadding && styles.evenPadding,
              )}
            >
              {children}
            </div>
            {!removeFooter && (
              <DetailsFooter
                hideModal={hidePropertyModal}
                actionButtonVariant={actionButtonVariant}
                actionButtonText={actionButtonText}
                showResetButton={showResetButton}
                resetButtonClick={resetButtonClick}
                actionButtonClick={actionButtonClick}
                disableReset={disableReset}
                disableActionButton={disableActionButton}
                actionButtonStyle={actionButtonStyle}
              />
            )}
          </div>
        </Modal>
      ) : (
        <BottomSheetOverlay
          hideBottomSheetOverlay={hidePropertyModal}
          innerClassName={styles.detailsModalContainer}
          reducedZIndex={reducedZIndex}
          isHistoryPush={shouldHistoryPush}
          name="PropertyDetailsModal"
          className={bottomSheetClassName}
          noBodyLock={noBodyLock}
          {...(mobileSize ? { size: mobileSize } : {})}
        >
          <div className={styles.wrapper}>
            <DetailsHeader
              hidePropertyModal={hidePropertyModal}
              isDesktop={isDesktop}
              header={header}
              isListingPage={isListingPage}
            />
            <div
              className={formatClassNames(
                styles.detailsBody,
                bodyWithNoPadding && styles.noPadding,
                bodyWithEvenPadding && styles.evenPadding,
                fitContent && styles.fitContent,
              )}
            >
              {children}
            </div>
            {!removeFooter && (
              <DetailsFooter
                hideModal={hidePropertyModal}
                actionButtonVariant={actionButtonVariant}
                actionButtonClick={actionButtonClick}
                actionButtonText={actionButtonText}
                showResetButton={showResetButton}
                resetButtonClick={resetButtonClick}
                disableReset={disableReset}
                disableActionButton={disableActionButton}
                isListingPage={isListingPage}
              />
            )}
          </div>
        </BottomSheetOverlay>
      )}
    </>
  );
};

export default wrapperHOC(PropertyDetailsModal, {
  componentName: "PropertyDetailsModal-PropertyPage",
  showForChina: true,
});
